import * as actionTypes from '../actions/actionTypes';
import * as actions from './index';
import * as ConfigTypes from 'config/ConfigTypes';
import * as CartHelper from "helpers/CartHelper";
import { showConfirmMsgDlg } from 'helpers/AppHelper';

export const updateCartObjectsSuccess = (data) => {
    console.log("LOGS: updateCartObjectSuccess data", data);
    return {
        type: actionTypes.CART_UPDATE_CARTOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateCartObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateCartObjectsSuccess(obj));
    }
}

export const setCartInitialState = () => {
    return {
        type: actionTypes.CART_SET_INITIAL_STATE
    }
}

export const addToFeCart = ({ clid, showdates }) => {
    return async (dispatch) => {
        try {
            if (clid) {
                console.log("LOGS: addToFeCart clid showdates", clid, showdates);
                const res = await window.flow.sdkFeReAddToCart(clid, showdates);
                if (res) {
                    console.log("LOGS: addToFeCart res", res);
                    setTimeout(() => {
                        console.log("LOGS: getCart res");
                        dispatch(actions.getCart());
                    }, 1000);
                }
            }
        } catch (err) {
            console.log("LOGS: LAMTEST addToFeCart err", err);
            dispatch(actions.updateCartObjects({ cartMsg: 'not logged in' }));
        }
    }
}

export const editFeRentel = (pars) => {
    return async (dispatch) => {
        try {
            console.log("LOGS: editFeRentel pars", pars);
            if (pars && pars.rentels) {
                const res = await window.flow.sdkFeReEditRentel(pars);
                if (res) {
                    console.log("LOGS: LAMTEST editFeRentel res", res);
                }
            }
        } catch (err) {
            console.log("LOGS: LAMTEST editFeRentel err", err);
        }
    }
}

export const sendFeReSubmitCart = (pars) => {
    return async (dispatch) => {
        try {
            if (pars) {
                console.log("LOGS: sdkFeReSubmitCart pars", pars);
                const res = await window.flow.sdkFeReSubmitCart(pars);
                if (res) {
                    console.log("LOGS: sdkFeReSubmitCart res", res);
                }
            }
        } catch (err) {
            console.log("LOGS: LAMTEST sdkFeReSubmitCart err", err);
        }
    }
}

export const removeFromFeCart = ({ rentelid }) => {
    return async (dispatch) => {
        try {
            if (rentelid) {
                console.log("LOGS: LAMTEST removeFromCart id", rentelid);
                const res = await window.flow.sdkFeReRemoveFromCart(rentelid);
                if (res) {
                    console.log("LOGS: LAMTEST removeFromFeCart res", res);
                }
            }
        } catch (err) {
            console.log("LOGS: LAMTEST removeFromFeCart err", err);
        }
    }
}

export const getList = async ({ list, itemlist }) => {
    let newCartList = [];
    for (let i = 0; i < list.length; i++) {
        let found;
        let li = list[i];
        let tmp;
        if (itemlist && itemlist.length) found = itemlist.find(entry => entry.id == li.spots_id)
        if (found && found.data && found.data.metadata) tmp = found;
        else {
            try {
                const res = await window.flow.sdkGetItem(li.spots_id);
                tmp = res;
            } catch (err) { console.log("LOGS: getList err", err) }
        }
        if (tmp && tmp.data) {
            let nShows = [];
            if (li.shows) {
                try {
                    nShows = JSON.parse(li.shows);
                } catch (err) { console.log("LOGS: getList err", err) }
            }
            let fi = `${ConfigTypes.ONLY_CART}txt2`;
            let fiVal = li.txt19;
            if (li.txt14) fiVal += ' ' + li.txt14;
            newCartList.push({
                metadata: { fields: { ...tmp.data.metadata.fields, [fi]: fiVal } }, ...li,
                id: tmp.data.id, rentelid: li.id, shows: nShows
            });
        }
    }
    return newCartList;
}

export const getShowDates = ({ newCartList }) => {
    let itemsShowsObj = {};
    if (newCartList && newCartList.length) {
        newCartList.forEach(item => {
            itemsShowsObj[item.id] = {};
            if (item.item.showdates) {
                let showdates = item.item.showdates;
                try {
                    item.showdates = JSON.parse(showdates);
                    if (item.item.shows) {
                        item.item.shows = JSON.parse(item.item.shows);
                    }
                } catch (err) { console.log("LOGS: getList err", err) }
                if (item.showdates && item.showdates.length) {
                    item.showdates.forEach((date, idx) => {
                        itemsShowsObj[item.id][date] = item.shows[idx] || 1;
                    })
                }
            }

            if (!item.item.shows) item.item.shows = [];
        })
    }
    return { itemsShowsObj };
}

export const getCart = () => {
    return async (dispatch, getState) => {
        try {
            console.log("LOGS: getCart sdkFeReGetCart");
            const res = await window.flow.sdkFeReGetCart();
            if (res) {
                console.log("LOGS: getCart sdkFeReGetCart res", res);
                if (res && res.data) {
                    let cartData = res.data;
                    let processnumber = res.data.id;
                    if (cartData && cartData.parsedrentels) {
                        let list = cartData.parsedrentels;
                        console.log("LOGS: getCart list", list);
                        if (list && list.length) {
                            let newCartList = list.map((li, idx) => {
                                try { if (li.item.shows) li.item.shows = JSON.parse(li.item.shows) } catch (e) { }
                                return {
                                    metadata: { fields: { ...li.item } }, ...li,
                                    rentelid: li.id, shows: li.item.shows, position: idx + 1
                                }
                            });
                            const { itemsShowsObj } = getShowDates({ newCartList });
                            dispatch(actions.updateCartObjects({
                                cartData, processnumber,
                                itemsCartList: newCartList, itemsShowsObj: itemsShowsObj,
                            }));
                        }
                    }
                }
            }
        } catch (err) {
            console.log("LOGS: getCart err", err);
            dispatch(actions.updateCartObjects({ cartMsg: 'not logged in' }));
        }
    }
}

export const getFeRents = () => {
    return async (dispatch, getState) => {
        try {
            console.log("LOGS: getFeRents");
            const res = await window.flow.sdkFeReGetRents();
            console.log("LOGS: getFeRents res", res);
            if (res && res.data) {
                dispatch(actions.updateCartObjects({ itemsRentalList: res.data }));
            }
        } catch (err) {
            console.log("LOGS: getCart err", err);
        }
    }
}

export const getWatchlists = () => {
    return async (dispatch, getState) => {
        try {
            console.log("LOGS: getWatchlists");
            const res = await window.flow.sdkFeReGetWatchlists();
             console.log("LOGS: getWatchlists sdkFeReGetWatchlists res", res);
            if (res && res.success) {
                if(res.data && res.data.length){
                    let watchlists = [...res.data];
                    let worksWishList = CartHelper.toWishList({getState, watchlists, type: ConfigTypes.WORK});
                    let itemsWishList = CartHelper.toWishList({getState, watchlists, type: ConfigTypes.ITEM});
                    dispatch(actions.updateCartObjects({ watchlists, worksWishList, itemsWishList}));
                }
            }
        } catch (err) {
            console.log("LOGS: getWatchlists err", err);
        }
    }
}

export const showMsg = ({res, obj}) => {
     if(obj.fm){
        let msg = obj.fm({id: 'couldNotAdd.msg'});
        if(res && res.msg) msg = res.msg;
        CartHelper.showFeCartMsg({ msg, fm:obj.fm});
     }
}

export const addToWatchlist = (obj) => {
    console.log("LOGS: addToWatchlist obj", obj);
    return async (dispatch, getState) => {
        let inObj;
        if(obj.work) inObj = CartHelper.getInObj({getState, entry: obj.work, type: ConfigTypes.WORK});
        else if(obj.item) inObj = CartHelper.getInObj({getState, entry: obj.item, type: ConfigTypes.ITEM});
        if(inObj){
            const {listid,sprid,type,fields} = inObj;
            console.log("LOGS: addToWatchlist inObj", inObj);
            try {
                const res = await window.flow.sdkFeReAddToWatchlist(listid,sprid,type,fields);
                if(!res || !res.success) showMsg({res, obj});
                if (res) {
                    console.log("LOGS: sdkFeReAddToWatchlist res", res);
                     if(obj.work && obj.item){
                        let itemInObj = CartHelper.getInObj({getState, entry: obj.item, type: ConfigTypes.ITEM});
                        console.log("LOGS: sdkFeReAddToWatchlist itemInObj", itemInObj);
                        if(itemInObj){
                            const {listid,sprid,type,fields} = itemInObj;
                            const itemRes = await window.flow.sdkFeReAddToWatchlist(listid,sprid,type,fields);
                            if(!itemRes || !itemRes.success) showMsg({res: itemRes, obj});
                            console.log("LOGS: sdkFeReAddToWatchlist itemRes", itemRes);
                        }
                    }
                }
            } catch (err) {
                showMsg({obj});
                console.log("LOGS: sdkFeReAddToWatchlist err", err);
            }
        }
    }
}

export const removeFromWatchlist = ({listid,listelid, fm}) => {
    return async (dispatch, getState) => {
        try {
            console.log("LOGS: sdkFeReRemoveFromWatchlist");
            const res = await window.flow.sdkFeReRemoveFromWatchlist(listid,listelid);
             console.log("LOGS: sdkFeReRemoveFromWatchlist res", res);
            if(!res || !res.success){
                let msg = fm({id: 'couldNotRemove.msg'});
                if(res.msg) msg = res.msg;
                CartHelper.showFeCartMsg({ msg, fm});
            }
        } catch (err) {
            console.log("LOGS: removeFromWatchlist err", err);
            let htmlMsg = fm({id: 'couldNotRemove.msg'});
            showConfirmMsgDlg({htmlMsg, formatMessage: fm, cb: () => {}});
        }
    }
}

export const getBlocks = ({id}) => {
    return async (dispatch, getState) => {
        try {
            console.log("LOGS: GetBlocks");
            const res = await window.flow.sdkFeReGetBlocksByClids(id);
            console.log("LOGS: GetBlocks res", res);
            if (res && res.data) {
                let curBlocksObj = getState().cart.cartObjects.curBlocksObj
                dispatch(actions.updateCartObjects({ curBlocksObj: {...curBlocksObj,...res.data} }));
            }
        } catch (err) {
            console.log("LOGS: GetBlocks err", err);
        }
    }
}